import React, { memo } from 'react';
import Status from 'design-system/Status';
const RentReportingStatus = ({ active, style }) => (<Status active={active} activeText="Tracking" inactiveText="Not tracking" style={style}/>);
export default memo(RentReportingStatus);
